import { EncryptedStorageKey } from '@utils/environmentVariables/environmentVariables';
import { EncryptStorage } from 'encrypt-storage';

export enum EncryptedStorageKeys {
  AccessToken = 'accessToken',
}

export const encryptedStorage = new EncryptStorage(EncryptedStorageKey ?? '');
